import styled from 'styled-components';
import { Layout } from 'antd';

const { Content } = Layout;

export const LayoutContainer = styled(Layout)`
  &.ant-layout {
    height: 100vh;
    width: 100vw;
  }
`;

export const ContentWithMenu = styled(Layout)`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.palette.background};
`;

export const StyledContent = styled(Content)`
  &.ant-layout-content {
    overflow-y: overlay;
  }

  padding: 2rem;
`;

export const StyledBox = styled.div`
  background-color: ${props => props.theme.palette.common.white};
  border: 1px solid ${props => props.theme.palette.border};
  padding: 2rem;
  border-radius: ${props => props.theme.borderRadius.normal};
`;
